export default __webpack_public_path__ + "static/media/wheelchair2.fac229d6.jpg";